//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { CreatorsCampaignsProposalDetailsResponse } from '@apis/creators-campaigns/creators-proposals/CreatorsProposalsApiModel';
import { Serialized } from '@utils/types/Serialized';

export const deserializeCreatorsCampaignsProposalDetailsData = (
  ProposalDetailsData: Serialized<CreatorsCampaignsProposalDetailsResponse>,
): CreatorsCampaignsProposalDetailsResponse => ({
  ...ProposalDetailsData,
  eventsTimestamp: Object.fromEntries(
    Object.entries(ProposalDetailsData.eventsTimestamp ?? {}).map(
      ([key, value]) => [key, value ? new Date(value) : undefined],
    ),
  ),
});
